<template lang="html">
    <button @click.prevent="starLesson" class="star" type="button" name="button">
        <span v-if="user.type == 'player'">
            <img v-if="lesson.starred" src="@/assets/icons/star-fill.svg" />
            <img v-else src="@/assets/icons/star-unfilled.svg" />
        </span>
        <span v-else>
            <img v-if="lesson.pro_starred" src="@/assets/icons/star-fill.svg" />
            <img v-else src="@/assets/icons/star-unfilled.svg" />
        </span>
    </button>
</template>

<script>
export default {
    name: "lesson-star",
    props: {
        lesson: {
            type: Object,
            required: true,
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        starLesson() {
            if (this.$store.state.user.type == "player") {
                this.lesson.starred = !this.lesson.starred;
            } else {
                this.lesson.pro_starred = !this.lesson.pro_starred;
            }

            window.axios.post("/lesson/" + this.lesson.id + "/star", this.lesson).then((lesson) => {
                this.$store.dispatch("updateLesson", lesson.data);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.star {
    background: none;
    border: 0px;
    &:focus {
        outline: 0;
    }
}
</style>
